import MovieList from './movie-scroll.vue'

export default MovieList;
